import { Box, Flex, Heading, StyleProps } from "@chakra-ui/react";
import React from "react";

import { GAEventDetails } from "../../utils/googleAnalytics";
import { Button } from "../Buttons";
import { UpgradeRequestImage } from "../Images";

type UpgradePageProps = StyleProps & {
  header: React.ReactNode;
  body: React.ReactNode;
  buttonText: string;
  bhEvent?: GAEventDetails;
  secondaryButton?: React.ReactNode;
  splash: React.ReactNode;
  requestSubmitted: boolean;
  maxWidth?: number;
  onClick(): void;
};

/** UI component for upgrade pages */
export const UpgradePage: React.FC<UpgradePageProps> = ({
  header,
  body,
  buttonText,
  bhEvent,
  secondaryButton,
  splash,
  requestSubmitted,
  maxWidth,
  onClick,
  ...styles
}) => {
  return (
    <Flex
      align="center"
      justify="space-around"
      color="gray.800"
      bg="linear-gradient(0deg, #E9F5FF 0%, #E9F5FF 100%), linear-gradient(180deg, rgba(113, 165, 214, 0.60) 100.29%, rgba(173, 223, 244, 0.60) 200.29%);"
      {...styles}
    >
      {requestSubmitted ? (
        <Box textAlign="center" mb="5%">
          <UpgradeRequestImage w={450} h="auto" />
          <Heading as="h3" size="xl" fontWeight="semibold" mb={3} mt={8}>
            Thank you for your interest.
          </Heading>
          <Box fontSize="lg">We&apos;ll be in touch with you shortly.</Box>
        </Box>
      ) : (
        <Flex
          wrap="wrap-reverse"
          gap="6"
          align="center"
          justify="center"
          direction={{ base: "column", lg: "row" }}
        >
          <Flex
            direction="column"
            maxW={maxWidth || 540}
            minW={{ base: "auto", md: 400 }}
            flex="1"
            align={{ base: "stretch", lg: "start" }}
          >
            <Heading as="h3" fontSize="4xl" fontWeight="semibold">
              {header}
            </Heading>
            <Box mt={3} fontSize={{ base: "lg", sm: "xl" }}>
              {body}
            </Box>
            <Box
              position={{ base: "fixed", sm: "static" }}
              backgroundColor={{
                base: "#DBEDFC",
                sm: "transparent",
              }}
              bottom={0}
              left={0}
              right={0}
              p={{ base: 6, sm: 0 }}
              mt={{ base: 0, sm: 8 }}
              zIndex={{ base: 1000, sm: 0 }}
            >
              <Button
                onClick={onClick}
                width="100%"
                px="8"
                fontWeight="500"
                bhEvent={bhEvent}
              >
                {buttonText}
              </Button>
              {secondaryButton}
            </Box>
          </Flex>
          <Box
            position="relative"
            maxW={maxWidth || 540}
            minW={{ base: "auto", md: 448 }}
            flex="1"
          >
            {splash}
          </Box>
        </Flex>
      )}
    </Flex>
  );
};
